export const QR_SCAN_CONFIG = {
    fps: 10,
    qrbox: { width: 250, height: 250 },
};

/**
 * Start scanning with rear camera, falling back to front-facing.
 */
export async function startHtml5QrcodeCamera(html5QrCode, onScanSuccess) {
    const onScanError = () => {};

    try {
        await html5QrCode.start(
            { facingMode: "environment" },
            QR_SCAN_CONFIG,
            onScanSuccess,
            onScanError
        );
        return;
    } catch {
        // Desktop / front-facing fallback when environment camera is unavailable.
    }

    await html5QrCode.start(
        { facingMode: "user" },
        QR_SCAN_CONFIG,
        onScanSuccess,
        onScanError
    );
}

/**
 * Stop the camera and clear the reader DOM.
 */
export async function stopHtml5QrcodeCamera(html5QrCode) {
    if (!html5QrCode) return;

    try {
        if (html5QrCode.isScanning) {
            await html5QrCode.stop();
        }
        html5QrCode.clear();
    } catch (err) {
        console.error("Failed to stop QR camera", err);
    }
}
